import * as Sentry from '@sentry/react';
import { SENTRY_DATA_COLLECTION } from 'dg-web-shared/lib/SentryDataCollection';
import { tabFlowId } from 'dg-web-shared/lib/FlowId';
import { withBackendRequestId } from 'dg-web-shared/lib/SentryRequestId';
import { useEffect } from 'react';
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from 'react-router';

export function init(dsn: string): void {
    Sentry.init({
        dsn: dsn,
        attachStacktrace: true,
        dataCollection: SENTRY_DATA_COLLECTION,
        initialScope: { tags: { service: 'operator-app' } },
        beforeBreadcrumb: withBackendRequestId,
        tunnel: '/ui-api/sentry-tunnel',
        integrations: [
            Sentry.browserSessionIntegration({ lifecycle: 'page' }),
            Sentry.reactRouterBrowserTracingIntegration({
                useEffect,
                createRoutesFromChildren,
                matchRoutes,
                useLocation,
                useNavigationType,
            }),
            Sentry.captureConsoleIntegration({
                levels: ['error'],
            }),
        ],
    });
    // sets the flow_id tag before the first request
    tabFlowId();
}
